import React from "react"
import { connect } from "react-redux"

const NumberCartItems = props => <span>{props.ItemsInCart}</span>

const mapStateToProps = state => {
  return {
    ItemsInCart: state.shoppingCart.products.length,
  }
}

// calls to connect
export default connect(mapStateToProps)(NumberCartItems)
